import { Table, Tabs, Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Announcements from "./Announcements";
import QuickTips from "./QuickTips";
import ProductNews from "./ProductNews";
import ModuleIntelligenceDashboard from "components/ModuleIntelligenceDashboard";
import ModuleSummaryDrawer from "components/ModuleSummaryDrawer";
import { FaBullhorn, FaLightbulb, FaRadio } from "react-icons/fa6";
import { ThunderboltFilled } from "@ant-design/icons";
import execute from "hooks/execute";
import { protectedResources } from "config/msalConfig";
import { useUser } from "components/UserContext";
import AI_FEATURE_KEYS from "constants/aiFeatureKeys";

const ModuleIntelligenceTab = () => {
  const [selectedModule, setSelectedModule] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleModuleClick = (module) => {
    setSelectedModule(module);
    setDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setDrawerVisible(false);
  };

  return (
    <>
      <div className="mb-4">
        <ModuleIntelligenceDashboard onModuleClick={handleModuleClick} />
      </div>
      <ModuleSummaryDrawer
        visible={drawerVisible}
        module={selectedModule}
        onClose={handleDrawerClose}
      />
    </>
  );
};

function InformationSection() {
  const { userDetails, hasFeatureAccess } = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [customerEtls, setCustomerEtls] = useState([]);
  const [activeTab, setActiveTab] = useState("0");
  const canViewExecutiveReport = hasFeatureAccess(AI_FEATURE_KEYS.EXEC_REPORT_VIEW);

  const tabItems = [
    ...(canViewExecutiveReport ? [{
      key: "0",
      label: (
        <div className="flex items-center gap-2">
          <ThunderboltFilled style={{ color: '#F16622' }} />
          <b>Module Intelligence</b>
        </div>
      ),
      children: <ModuleIntelligenceTab />,
    }] : []),
    {
      key: "1",
      label: (
        <div className="flex items-center gap-2">
          <FaBullhorn />
          <b>Announcement</b>
        </div>
      ),
      children: <Announcements />,
    },
    {
      key: "2",
      label: (
        <div className="flex items-center gap-2">
          <FaLightbulb />
          <b>Quick Tips</b>
        </div>
      ),
      children: <QuickTips />,
    },
    {
      key: "3",
      label: (
        <div className="flex items-center gap-2">
          <FaRadio />
          <b>Product News</b>
        </div>
      ),
      children: <ProductNews />,
    },
  ];

  const fetchCustomerEtls = async (values) => {
    console.log(userDetails);
    console.log("fetching Roles");
    setLoading(true);
    try {
      const response = await execute(
        "GET",
        `${protectedResources.api.baseEndPoint}/ETL_management/customer/${userDetails.CustomerID}`
      );
      if (response) {
        if (response.success) {
          console.log("customerEtls");
          console.log(response.data);
          setCustomerEtls(response.data);
          // console.log(orgModules)

          setLoading(false);
          // setSearchResults(response.data.customers); // Assuming customers are part of the response
        } else {
          setError(
            response.message || "No organization found for the specified name"
          );
          setLoading(false);
        }
      }
    } catch (err) {
      setError("Failed to fetch data: " + err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!process.env.REACT_APP_DISABLE_ETL_Feature) {
      fetchCustomerEtls();
    }
  }, [userDetails]);

  useEffect(() => {
    if (!canViewExecutiveReport && activeTab === "0") {
      setActiveTab("1");
    }
  }, [canViewExecutiveReport, activeTab]);

  const columns = [
    {
      title: "ETL Name",
      dataIndex: "Name",
      key: "Name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "ETL Message",
      dataIndex: "ETL_Message",
      key: "ETL_Message",
    },
    {
      title: "ETL Result",
      dataIndex: "ETL_Result",
      key: "ETL_Result",
    },
  ];

  console.log(process.env.REACT_APP_DISABLE_ETL_Feature);
  return (
    <div className="mt-0 mb-3">
      <div className="bg-white mr-6 py-5 px-6 rounded-lg border border-gray-200 shadow-sm mb-4">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-8 bg-gradient-to-b from-[#F16622] to-[#ff8c42] rounded-full"></div>
          <h1 className="text-gray-800 font-semibold text-xl">
            Business Intelligence for Human Services
          </h1>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed max-w-4xl ml-7">
          Empowering Human Services Providers with data-driven insights for IDD, Behavioral Health, and more.
        </p>
      </div>
      <div className="grid grid-cols-12">
        <div className={activeTab === "0" ? "col-span-12" : "col-span-8"}>
          <Tabs
            className=""
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            defaultActiveKey="0"
            type="card"
            size="small"
            items={tabItems}
          />
        </div>
        {activeTab !== "0" && (
          <div className="flex mr-6 col-span-4 mt-0 2xl:mt-10 justify-center">
            <img
              className="w-[28rem] object-contain"
              src="/human.png"
              alt="human"
            />
          </div>
        )}
        {!process.env.REACT_APP_DISABLE_ETL_Feature && (
          <Table
            className="lg:w-[50%] w-full border-gray-200 border-solid rounded-md"
            bordered
            loading={loading}
            title={() => "ETL Information"}
            pagination={false}
            columns={columns}
            dataSource={customerEtls}
          />
        )}
      </div>
    </div>
  );
}

export default InformationSection;
